<div mat-dialog-content>
  <button (click)="onClose()" mat-icon-button style="position: absolute;right: 0;top: 0;">
    <mat-icon>clear</mat-icon>
  </button>
  <h2 class="mat-h2" style="text-align: center;">{{dialog.HeaderMessage}}</h2>
  <div style="height: 10px;">
    <mat-divider style="border-color: #ccc;"></mat-divider>
  </div>
  <ag-grid-angular #agGrid style="width: 100%;height:230px" class="ag-theme-blue" [gridOptions]="gridOptions" [rowData]="rowData">
  </ag-grid-angular>
  <div mat-dialog-actions>
    <span class="fill-remaining-space"></span>
    <button mat-button [mat-dialog-close]="false">{{dialog.ButtonNo}}</button>
    <!-- <button mat-button (click)="onClick()" [disabled]="FoerderTyp.length == 0 && !FoerderTypSelected" cdkFocusInitial>{{dialog.ButtonOk}}</button> -->
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/_vertrag/vertrag-list/termin-list/termin-list.component.html